var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnityIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.543,
    height: 20.339,
    viewBox: "0 0 26.543 20.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online-meeting",
    transform: "translate(0 -29.912)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(10.098 42.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(12.753 42.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(15.407 42.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M17.837,105.429a3.493,3.493,0,1,1,3.493-3.493A3.493,3.493,0,0,1,17.837,105.429Zm0-5.95a2.457,2.457,0,1,0,2.456,2.457A2.457,2.457,0,0,0,17.837,99.479Z",
    transform: "translate(-12.857 -61.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M9.443,163.111H.518A.518.518,0,0,1,0,162.593v-1.785a4.981,4.981,0,1,1,9.962,0v1.785A.518.518,0,0,1,9.443,163.111Zm-8.406-1.037H8.925v-1.267a3.944,3.944,0,1,0-7.888,0Z",
    transform: "translate(0 -112.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M177.762,105.429a3.493,3.493,0,1,1,3.493-3.493A3.493,3.493,0,0,1,177.762,105.429Zm0-5.95a2.457,2.457,0,1,0,2.456,2.457A2.457,2.457,0,0,0,177.762,99.479Z",
    transform: "translate(-156.199 -61.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M169.366,163.111h-8.925a.518.518,0,0,1-.518-.518v-1.785a4.981,4.981,0,1,1,9.962,0v1.785A.518.518,0,0,1,169.366,163.111Zm-8.406-1.037h7.888v-1.267a3.944,3.944,0,1,0-7.888,0Z",
    transform: "translate(-143.342 -112.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M81.636,40.392a.518.518,0,0,1-.518-.518V38.341H80.6a1.692,1.692,0,0,1-1.69-1.69V31.6a1.692,1.692,0,0,1,1.69-1.69h6.69a1.692,1.692,0,0,1,1.69,1.69v5.049a1.692,1.692,0,0,1-1.69,1.69H83.9L82,40.24A.518.518,0,0,1,81.636,40.392ZM80.6,30.949a.653.653,0,0,0-.653.653v5.049a.653.653,0,0,0,.653.653h1.037a.518.518,0,0,1,.518.518v.8l1.165-1.165a.518.518,0,0,1,.367-.152h3.6a.653.653,0,0,0,.653-.653V31.6a.653.653,0,0,0-.653-.653Z",
    transform: "translate(-70.727)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityIconWhite);
export default __webpack_public_path__ + "static/media/unityIconWhite.0c51054fa6563cbc6cba0216a6a6981f.svg";
export { ForwardRef as ReactComponent };